module.exports = __webpack_public_path__ + "static/nav-background-sq-mobile-686ebbad912ab22935edb02cede3a3bc.png";